export const msalConfig = {
  auth: {
    // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
    clientId: '7db8ea87-27a7-42f5-a228-d3c82041ebb1',
    // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
    authority: 'https://login.microsoftonline.com/common',
    // Full redirect URL, using a blank html file as recommended by microsoft: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/initialization.md#redirecturi-considerations
    redirectUri: 'https://local.hubspotqa.com/signup-hubspot-blank'
  },
  cache: {
    cacheLocation: 'sessionStorage',
    // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge

  }
};